__turbopack_context__.v({
  "className": "courier_prime_fab9dd70-module__DqIOfG__className",
  "variable": "courier_prime_fab9dd70-module__DqIOfG__variable",
});
